import { TH } from '../lib/constants.js';
import { YR } from '../lib/dateState.js';
import { computeYearSummary } from '../lib/helpers.js';
import { Btn } from '../components/Basic.jsx';

export function YearCloseView({t,st,go}){
  const summary=computeYearSummary(st);
  const pt=TH[st.myTheme]||TH.neon;
  return(
    <div className="screen fade" style={{background:`linear-gradient(180deg,${t.ac}26,${t.bg} 55%)`}}>
      <div style={{padding:"14px 16px",display:"flex",alignItems:"center",gap:11,flexShrink:0}}>
        <div onClick={()=>go("profile_me")} style={{width:32,height:32,borderRadius:"50%",background:t.card,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",fontSize:14,color:t.tx}}>←</div>
      </div>
      <div style={{padding:"10px 22px 40px",flex:1,overflowY:"auto",textAlign:"center"}}>
        <div style={{fontSize:52,marginBottom:10}}>🎆</div>
        <div style={{fontSize:22,fontWeight:800,color:t.tx,fontFamily:"Inter,sans-serif",marginBottom:6}}>Il tuo {YR} sta per chiudersi</div>
        <div style={{fontSize:13,color:t.soft,fontFamily:"Inter,sans-serif",lineHeight:1.6,marginBottom:28}}>Un anno di scatti, un giorno alla volta. Ecco cosa hai costruito.</div>

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:11,marginBottom:24}}>
          <div style={{background:t.card,borderRadius:16,padding:"18px 12px"}}>
            <div style={{fontSize:28,fontWeight:800,color:t.tx,fontFamily:"Inter,sans-serif"}}>{summary.totalPages}</div>
            <div style={{fontSize:10,color:t.soft,fontFamily:"Inter,sans-serif",marginTop:3}}>pagine scritte</div>
          </div>
          <div style={{background:t.card,borderRadius:16,padding:"18px 12px"}}>
            <div style={{fontSize:28,fontWeight:800,color:t.tx,fontFamily:"Inter,sans-serif"}}>{summary.longestStreak}</div>
            <div style={{fontSize:10,color:t.soft,fontFamily:"Inter,sans-serif",marginTop:3}}>striscia più lunga</div>
          </div>
          {summary.topMonth&&<div style={{background:t.card,borderRadius:16,padding:"18px 12px"}}>
            <div style={{fontSize:18,fontWeight:800,color:t.tx,fontFamily:"Inter,sans-serif"}}>{summary.topMonth}</div>
            <div style={{fontSize:10,color:t.soft,fontFamily:"Inter,sans-serif",marginTop:3}}>il tuo mese più attivo</div>
          </div>}
          <div style={{background:t.card,borderRadius:16,padding:"18px 12px"}}>
            <div style={{fontSize:28,fontWeight:800,color:t.tx,fontFamily:"Inter,sans-serif"}}>{summary.filtersUsed}</div>
            <div style={{fontSize:10,color:t.soft,fontFamily:"Inter,sans-serif",marginTop:3}}>filtri diversi usati</div>
          </div>
        </div>

        <Btn full fn={()=>go("print_preview",{book:{type:"annual",title:`Oncer ${YR}`,theme:st.myTheme,pages:(st.books[YR]&&st.books[YR].pages)||[]}})} style={{background:"linear-gradient(135deg,#FF2D6B,#7B2FFF)",color:t.tx,padding:"15px",borderRadius:40,fontSize:14,fontWeight:700,fontFamily:"Inter,sans-serif",marginBottom:12}}>🖨 Stampa il libro del {YR}</Btn>
        <div style={{fontSize:11,color:t.soft,fontFamily:"Inter,sans-serif",lineHeight:1.6}}>Il {YR+1} comincia da solo, alla tua prossima pagina — nessun pulsante da premere. Il libro di quest'anno resta per sempre così com'è.</div>
      </div>
    </div>
  );
}
